const envVariables = process.env

const Config: any = {}

Object.keys(envVariables).forEach(variable => {
   if (variable.includes('NX')) {
      const envKey = variable.replace('NX_', '')
      Config[envKey] = envVariables[variable]
   }
})

export { Config }
